function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48.57,10.57A3.64,3.64,0,0,1,52.2,14.2V49.8a3.64,3.64,0,0,1-3.63,3.63H19.39V14.2A3.64,3.64,0,0,1,23,10.57H48.57m0-3.52H23a7.17,7.17,0,0,0-7.15,7.15V57h32.7a7.17,7.17,0,0,0,7.15-7.15V14.2a7.17,7.17,0,0,0-7.15-7.15Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.45,57h-7.3a9.64,9.64,0,0,1-9.63-9.63V29.89a6,6,0,0,1,6-6h5.77v3.52H12.49A2.45,2.45,0,0,0,10,29.89V47.32a6.12,6.12,0,0,0,6.11,6.11h7.3Z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 25.53,
  y: 40.37,
  width: 20.64,
  height: 3.52,
  rx: 1.76
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 27.77,
  y: 32.8,
  width: 16.15,
  height: 3.52,
  rx: 1.76
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 30.26,
  y: 21.58,
  width: 11.18,
  height: 3.52,
  rx: 1.76
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 30.26,
  y: 21.58,
  width: 11.18,
  height: 3.52,
  rx: 1.76,
  transform: "translate(12.51 59.18) rotate(-90)"
});

function SvgBehavior(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_\u7D2F\u8BA1\u76D1\u7BA1\u8BCA\u7597\u884C\u4E3A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehavior);
export default __webpack_public_path__ + "static/media/behavior.ec853752.svg";
export { ForwardRef as ReactComponent };